package fr.manyverse.app.infrastructure.monitoring

import co.touchlab.kermit.Severity

/**
 * Remontée des crashs et des erreurs vers un service externe (Sentry).
 *
 * Android, iOS et desktop passent par le SDK Kotlin Multiplatform de Sentry. Sur le web, ce SDK
 * ne contient que des implémentations vides : on passe alors par `@sentry/browser`.
 */
interface CrashReporter {
    fun start(config: CrashReporterConfig)

    /** Rattache les événements suivants à un utilisateur Supabase, ou détache si `null`. */
    fun setUserId(userId: String?)

    /** Ajoute une ligne de log au fil d'Ariane joint au prochain événement envoyé. */
    fun addBreadcrumb(severity: Severity, tag: String, message: String)

    fun captureException(throwable: Throwable, tag: String, message: String)
}

data class CrashReporterConfig(
    val dsn: String,
    val release: String,
    val environment: String
)

/** Reporter utilisé quand aucun DSN n'est configuré : tout est ignoré. */
object NoOpCrashReporter : CrashReporter {
    override fun start(config: CrashReporterConfig) = Unit
    override fun setUserId(userId: String?) = Unit
    override fun addBreadcrumb(severity: Severity, tag: String, message: String) = Unit
    override fun captureException(throwable: Throwable, tag: String, message: String) = Unit
}

internal expect fun createCrashReporter(): CrashReporter
